import { createStyles, makeStyles } from '@material-ui/core/styles';

interface StyleProps {
  disabled: boolean;
  isMobile: boolean;
}

const useStyles = makeStyles(() =>
  createStyles({
    card: {
      width: ({ isMobile }: StyleProps) => (isMobile ? '100%' : '206px'),
      height: ({ isMobile }: StyleProps) => (isMobile ? '128px' : '280px'),
      borderRadius: '10px',
      border: ({ disabled }: StyleProps) => (disabled ? 'none' : '1px solid #FFFFFF'),
      boxShadow: 'none',
      alignSelf: 'center',
      margin: ({ isMobile }: StyleProps) => (isMobile ? '15px 0' : '30px 10px'),
      '&:hover': {
        color: '#FFFFFF',
        border: ({ disabled }: StyleProps) => (disabled ? 'none' : '1px solid #2D6DF6'),
        boxShadow: ({ disabled }: StyleProps) => (disabled ? 'none' : '0px 3px 6px #00000029'),
        opacity: 1,
      },
      background: ({ disabled }: StyleProps) => (disabled ? '#F4F4F4' : '#FFFFFF'),
    },
    divCard: {
      display: ({ isMobile }: StyleProps) => (isMobile ? 'flex' : 'grid'),
      padding: ({ isMobile }: StyleProps) => (isMobile ? '0px 10px' : 30),
    },
    labelPayment: {
      fontFamily: 'SuraSans-Negrita',
      fontSize: '18px',
      color: ({ disabled }: StyleProps) => (disabled ? '#888B8D' : '#00003F'),
      margin: '8px 0 0 0',
    },
    description: {
      fontWeight: 400,
      fontSize: '14px',
      fontFamily: 'SuraSans-Regular',
      color: '#888B8D',
    },
    actionArea: {
      height: '100%',
    },
    loading: {
      color: '#2D6DF6',
    },
    divLoading: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: '15px',
    },
  }),
);

export default useStyles;
